import items from './items'

export default {
  items,
}
